export const TOGGLE_MENU = 'TOGGLE_MENU';
